@if (ready) {
  <div class="flags-container"><div class="flags">
    @if (showSessionControls) {
      <div class="top-box" id="startEndSessionButton"><div class="flag flex-column">
        @if (!started) { Session <button class="button-start" (click)="start.emit()" [disabled]="busy">Start</button> }
        @else { {{ timerText }} <button class="button-end" (click)="end.emit()" [disabled]="busy">End</button> }
      </div></div>
    }
    <div class="flags-horizontal-w100" *ngIf="started" id="favoriteTargetsList">
      @for (target of favoriteTargets; track target.ID) {
        <app-target-selector [target]="target" [isBottomBox]="false" [promptCodes]="target.PromptCodes ?? []" [allPromptCodes]="target.AllPromptCodes ?? []" [subTargetsDictionary]="subTargetsDictionary" [promptSchedules]="promptSchedules" [isPreview]="preview" />
      }
    </div>
  </div></div>
  @if (started) {
    <div class="flags">
      @if (specialFavoriteTargets.length > 0) {
        <div class="flags-horizontal" id="specialFavoriteTargetsList">
          @for (target of specialFavoriteTargets; track target.ID) {
            <app-target-selector [target]="target" [isBottomBox]="false" [promptCodes]="target.PromptCodes ?? []" [allPromptCodes]="target.AllPromptCodes ?? []" [subTargetsDictionary]="subTargetsDictionary" [promptSchedules]="promptSchedules" [isPreview]="preview" />
          }
        </div>
      }
      <div id="behaviorsList" [class.flags-horizontal]="specialFavoriteTargets.length > 0" [class.flags-horizontal-w100]="specialFavoriteTargets.length === 0">
        @for (behavior of behaviors; track behavior.ID) {
          @if (behavior.BehaviorType === behaviorType.Frequency) { <app-box-behavior-frequency [text]="behavior.PatientBehaviorName ?? ''" [behaviorID]="behavior.ID ?? 0" [behavior]="behavior" [isPreview]="preview" [showDayValue]="false" /> }
          @if (behavior.BehaviorType === behaviorType.Duration) { <app-box-behavior-duration [text]="behavior.PatientBehaviorName ?? ''" [behaviorID]="behavior.ID ?? 0" [behavior]="behavior" [isPreview]="preview"  /> }
          @if (behavior.BehaviorType === behaviorType.Interval) { <app-box-behavior-interval [text]="behavior.PatientBehaviorName ?? ''" [behaviorID]="behavior.ID ?? 0" [behavior]="behavior" [isPreview]="preview" [Duration]="behavior.Interval ?? 0" /> }
          @if (behavior.BehaviorType === behaviorType.RateTimer) { <app-box-behavior-ratetimer [text]="behavior.PatientBehaviorName ?? ''" [behaviorID]="behavior.ID ?? 0" [behavior]="behavior" [isPreview]="preview" [Duration]="behavior.Interval ?? 0" /> }
          @if (behavior.BehaviorType === behaviorType.Intensity) { <app-box-behavior-intensity [text]="behavior.PatientBehaviorName ?? ''" [behaviorID]="behavior.ID ?? 0" [behavior]="behavior" [isPreview]="preview"  /> }
        }
      </div>
    </div>
    <ng-content select="[session-reminders]" />
    <div class="programs">
      @if (playlistTitle) {
        <div class="d-flex align-items-center"><button *ngIf="showPlaylistDetails" class="badge-program-details me-1 pointer" (click)="playlistDetails.emit()">?</button><div class="program-title">Playlist: {{ playlistTitle }}</div></div>
        <div *ngIf="playlistInstructions" [innerHTML]="playlistInstructions"></div>
      }
      @for (group of groups; track $index) {
        <div *ngIf="group.Title" class="program-title">{{ group.Title }}</div>
        @for (item of group.items; track $index) {
          <div *ngIf="item.Name" class="program-name" [style.border-left]="item.Color ? '10px solid ' + item.Color : null">
            <ng-container *ngIf="headingTemplate" [ngTemplateOutlet]="headingTemplate" [ngTemplateOutletContext]="{$implicit: item}" />
            <button *ngIf="!headingTemplate && item.ProgramID && programInstructions" class="badge-program-details pointer" (click)="programDetails.emit(item)">?</button>
            {{ item.Name }}
          </div>
          <div class="program-items">
            @for (target of item.Targets; track target.ID) {
              @if (targetVisible(target, item)) {
              <app-target-selector [target]="target" [isBottomBox]="bottomTargets" [promptCodes]="target.PromptCodes ?? []" [allPromptCodes]="target.AllPromptCodes ?? []" [subTargetsDictionary]="subTargetsDictionary" [promptSchedules]="promptSchedules" [isPreview]="preview" />
              }
            }
          </div>
          <ng-container *ngIf="notesTemplate" [ngTemplateOutlet]="notesTemplate" [ngTemplateOutletContext]="{$implicit: item}" />
        }
      } @empty { <p *ngIf="showEmptyMessage">No targets are available for this session.</p> }
    </div>
    @if (navigation.length > 0) {
      <div class="programs-list-container"><div class="programs-list">
        @for (item of navigation; track item.kind + ':' + item.id) {
          <div class="program-list-item" role="button" tabindex="0" (click)="navigationSelected.emit(item)" (keydown.enter)="navigationSelected.emit(item)" [class.selected]="item.selected"
            [ngStyle]="colorPatternStyle(item.color, item.pattern, '#b2cde2')"
            [style.box-shadow]="(item.color || item.pattern) && item.selected ? '0 0 0 4px #1c355e' : null">
            @if (item.completedTrials != null) { <span class="badge-count" [class.badge-count-green]="item.completedTrials >= (item.desiredTrials ?? 0)" [class.badge-count-red]="item.completedTrials < (item.desiredTrials ?? 0)">{{ item.completedTrials }}/{{ item.desiredTrials }}</span> }
            <div class="program-list-item-title" [style.color]="readableTextColor(item.color)">{{ item.kind === 'all' ? '' : (item.kind | titlecase) }}</div>
            <div class="program-list-item-name" [style.color]="readableTextColor(item.color)">{{ item.name }}</div>
            <div class="program-list-item-circles">@for (counter of item.counters; track $index) { <div class="program-list-item-circle" [style.background-color]="counter.color">{{ counter.count }}</div> }</div>
            <button *ngIf="item.kind === 'playlist' && showPlaylistDetails" class="badge-bottom-left pointer" (click)="$event.stopPropagation(); playlistDetails.emit()">?</button>
          </div>
        }
      </div>
      @if (allowSearch) {
        <div class="programs-list-buttons">
          <input *ngIf="showSearch" type="text" class="programs-list-search form-control" [ngModel]="searchText" (ngModelChange)="searchTextChange.emit($event)" placeholder="Search" />
          <div *ngIf="showSearch" class="programs-list-clearsearch" (click)="clearSearch.emit()"><i class="pi pi-times-circle"></i></div>
          <button class="programs-list-button" [class.active]="searchText.length > 0" (click)="searchToggle.emit()">Search</button>
          <button class="programs-list-button" (click)="next.emit()">Next</button>
        </div>
      }
      </div>
    }
  }
}
